import { navigate } from 'gatsby'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'

import '../less/layout.less'
import { AnalyticsService } from '../services'
import { HomepageProvider } from '../store/Context'
import AccessIbe from './accessibe'
import Footer from './footer/Container'
import GoogleAnalytics from './googleAnalytics'
import Header from './header/Header'
import ModalsContainer from './modals/Container'
import TikTok from './tiktok'

const Layout: React.FC<React.PropsWithChildren> = ({ children }) => {
  useEffect(() => {
    AnalyticsService.enableHotjar()
  }, [])

  useEffect(() => {
    const currentPath = window.location.pathname
    if (currentPath.startsWith('/au') || currentPath.startsWith('/nz') || currentPath.startsWith('/sg')) {
      if (currentPath.slice(3).startsWith('/')) {
        navigate(currentPath.slice(3))
      } else {
        navigate('/' + currentPath.slice(3))
      }
    }
  }, [])

  return (
    <HomepageProvider>
      <GoogleAnalytics />
      <AccessIbe />
      <TikTok />
      <Header />
      <main>{children}</main>
      <Footer />
      <ModalsContainer />
    </HomepageProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
